export function toggleNavbarBurger(navbarElement) {
    const navbarBurgers = navbarElement.querySelector('.navbar-burger')

    navbarBurgers.addEventListener('click', () => {
        const dataTarget = navbarBurgers.dataset.target
        const target = document.getElementById(dataTarget)

        navbarBurgers.classList.toggle('is-active')
        target.classList.toggle('is-active')
    })

    navbarElement.querySelectorAll('.navbar-link-icons').forEach(function (navbarLink) {
        navbarLink.addEventListener('click', (event) => {
            event.preventDefault()
            navbarLink.parentElement.nextElementSibling.classList.toggle('is-hidden-mobile')
            navbarLink.parentElement.classList.toggle('icon-switched')
        })
    })
}
